<template>
  <div class="container">
    <div class="row">
      <div class="col-xl-8 offset-xl-2 col-lg-10 offset-lg-1 col-md-12 col-sm-12 col-12">
        <div class="card mb-3">
          <div class="card-header"><BackIcon /><b-icon-sticky v-if="!$routerHistory.hasPrevious()"></b-icon-sticky> Open New Ticket</div>
          <div class="card-body">
            <div v-if="spinner1" class="text-center">
              <b-spinner variant="secondary" label="Spinning"></b-spinner>
            </div>

            <div v-if="!spinner1">
              <!-- <p>
                Please enter your name number, select the issue category, valid phone number and message body. <br />
                <b>NOTE:</b> You will be contacted and notified via UNILORIN email (e.g. CSC/19/2000@unilorin.edu.ng) and phone provided.
              </p> -->

              <form @submit.prevent="handleSubmit" enctype="multipart/form-data">
                <div class="row">
                  <!-- Select Student / Staff -->
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="category">Student or Staff</label>
                      <select @change="selectUserType($event)" class="form-control form-control-lg">
                        <option></option>
                        <option value="student">Student</option>
                        <option value="staff">Staff</option>
                      </select>
                    </div>
                  </div>
                  <!-- Student / Staff ID -->
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="matric">{{ idLabel }}</label>
                      <input
                        type="text"
                        v-model="matric"
                        class="form-control form-control-lg"
                        :placeholder="idPlaceholder"
                        :class="{ 'is-invalid': $v.matric.$error, 'is-valid': !$v.matric.$invalid }"
                      />
                      <div class="invalid-feedback">
                        <span v-if="!$v.matric.required">{{ idLabel }} is required.</span>
                        <!-- <span v-if="!$v.matric.minLength">Matric must be at least {{ $v.matric.$params.minLength.min }} letters.</span>
                        <span v-if="!$v.matric.maxLength">Matric must be at most {{ $v.matric.$params.maxLength.max }} letters.</span> -->
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Categories/subcategories -->
                <div class="row">
                  <!--  -->
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="category">Category</label>
                      <select @change="topSelected($event)" class="form-control form-control-lg">
                        <option value="Select..." selected>Select...</option>
                        <option v-for="(item, index) in categories" :key="index" :value="index">{{ item.name }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="category">Subcategory</label>
                      <select
                        v-model="category"
                        class="form-control form-control-lg"
                        :class="{ 'is-invalid': $v.category.$error, 'is-valid': !$v.category.$invalid }"
                      >
                        <option value="Select..." selected>Select...</option>
                        <option v-for="(item, index) in subCategories" :key="index" :value="item.uuid">{{ item.name }}</option>
                        <!--  <optgroup v-for="(cat, i) in categories" :key="i" :label="cat.name">
                          <option v-for="(sub, j) in cat.subCategories" :key="j" :value="sub.uuid">{{ sub.name }}</option>
                        </optgroup> -->
                        <!-- End option group -->
                      </select>
                      <div class="invalid-feedback">
                        <span v-if="!$v.category.required">Issue category is required.</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Faculties / Departements -->
                <div class="row">
                  <!-- faculties -->
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="category">Faculties</label>
                      <select @change="facultySelect($event)" class="form-control form-control-lg">
                        <option value="Select..." selected>Select...</option>
                        <option v-for="(fac, index) in faculties" :key="index" :value="index">{{ fac.name }}</option>
                      </select>
                    </div>
                  </div>
                  <!-- Department -->
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="department">Deparments</label>
                      <select v-model="departmentID" class="form-control form-control-lg">
                        <option value="Select..." selected>Select...</option>
                        <option v-for="(dept, index) in departments" :key="index" :value="dept.id">{{ dept.name }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="message">Message</label>
                  <vue-editor v-model="message" :editorToolbar="editorToolbar"></vue-editor>
                  <div class="text-danger text-xs" v-show="$v.message.$error">
                    <span v-if="!$v.message.required">Message is required.</span>
                    <span v-if="!$v.message.minLength">Message must be at least {{ $v.message.$params.minLength.min }} letters.</span>
                  </div>
                </div>

                <div class="form-group">
                  <b-icon-paperclip></b-icon-paperclip> <label for="att">Attachment(s)</label>
                  <vue-dropzone
                    id="dropzone"
                    ref="myVueDropzone"
                    :useCustomSlot="true"
                    :options="dropzoneOptions"
                    @vdropzone-error="uploadError"
                    @vdropzone-success="uploadSuccess"
                    @vdropzone-file-added="uploadFileAdded"
                  >
                    <div class="dropzone-custom-content" v-html="dropzoneOptions.myCustomContent"></div>
                  </vue-dropzone>
                </div>

                <button v-if="!spinner" class="btn btn-danger btn-lg" type="submit"><i class="far fa-paper-plane mr-1"></i> Send</button>
                <b-spinner v-if="spinner" variant="success" label="Spinning"></b-spinner>

                <!--  -->
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { VueEditor } from 'vue2-editor'
import { required, email, numeric, minLength, maxLength, minValue } from 'vuelidate/lib/validators'
import BackIcon from '@/components/BackIcon.vue'
import FaqModal from '@/components/FaqModal.vue'
import vue2Dropzone from 'vue2-dropzone'
import dropzoneOptions from '../helper/dropzoneOptions'

export default {
  name: 'TicketCreate',

  data() {
    return {
      spinner: false,
      spinner1: false,
      categories: [],
      subCategories: [],

      // Form data
      matric: '',
      category: '',
      message: '',
      attachments: [],
      facultyID: 0,
      departmentID: 0,

      editorToolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }]
      ],

      idPlaceholder: '',
      idLabel: 'Unique ID',
      group: '',

      // faculties / departments
      faculties: [],
      departments: []
    }
  },

  mounted() {
    this.spinner1 = true
    axios.get('/categories').then(res => {
      if (res.data.status == 'success') {
        this.categories = res.data.categoriesDirect
        this.faculties = res.data.faculties
        //console.log(this.faculties)
      }
      this.spinner1 = false
    })

    /* Form type */
    this.$swal
      .fire({
        //title: 'Ticket Type',
        //title: 'Are you a student or staff member?',
        text: 'If you are a student or staff, click "Yes", if you are a guest, click "No"',
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      })
      .then(result => {
        if (result.value) {
          // redirect to staff ticket
          //this.$router.push({ name: 'TicketCreateStudentStaff' })
        } else {
          this.$router.push({ name: 'TicketCreateGeneral' })
        }
      })
  },

  methods: {
    handleSubmit(e) {
      this.spinner = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.spinner = false
        return
      }

      let formData = new FormData()

      formData.append('matric', this.matric)
      formData.append('email', this.email)
      formData.append('name', this.name)
      formData.append('phone', this.phone)
      formData.append('subCategoryID', this.category)
      formData.append('message', this.message)
      formData.append('source', this.group)
      formData.append('priority', 'normal')
      formData.append('originURL', window.location.origin)
      formData.append('attachments', JSON.stringify(this.attachments))
      // faculty / department
      formData.append('facultyID', this.facultyID)
      formData.append('departmentID', this.departmentID)

      axios
        .post('/ticket/create', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(res => {
          if (res.data.status == 'success') {
            this.$v.$reset()
            //empty form
            this.name = ''
            this.email = ''
            this.category = ''
            this.message = ''
            this.attachments = []
            this.$refs.myVueDropzone.removeAllFiles()
            // fee back
            this.$swal(res.data.title, res.data.message, 'success')
            this.$router.push({ name: 'TicketDetails', params: { ref: res.data.ticketID } })
          } else {
            this.$swal('Oops!', res.data.message, 'error')
          }
          this.spinner = false
        })
        .catch(err => {
          this.spinner = false
        })
    },

    selectUserType(e) {
      if (e.target.value == 'Select...') {
        this.showSubCat = false
        return
      }
      this.idPlaceholder = e.target.value == 'student' ? 'e.g. 19/46KB0001' : 'e.g. S0000'
      this.idLabel = e.target.value == 'student' ? 'Matric Number' : 'Staff ID'
      this.group = e.target.value
    },

    topSelected(e) {
      if (e.target.value == 'Select...') {
        this.showSubCat = false
        return
      }
      this.subCategories = this.categories[e.target.value].subCategories
      this.showSubCat = true
      //this.category = this.categories[e.target.value].uuid
    },
    uploadFileAdded(file) {
      this.spinner = true // vdropzone-file-added( file)
    },
    uploadError(file) {
      this.spinner = false // vdropzone-file-added( file)
      this.$swal('Oops!', file.fileName + ' not uploaded.', 'error')
    },
    uploadSuccess(file, response) {
      this.spinner = false //vdropzone-success( file, response)
      this.attachments.push({
        name: response.link,
        size: file.size,
        original_name: file.name
      })
    },
    facultySelect(e) {
      console.log('faculty selected')
      if (e.target.value == 'Select...') {
        return
      }
      this.departments = this.faculties[e.target.value].departments
      this.facultyID = this.faculties[e.target.value].id
    }
  },

  computed: {
    topCategoryLabel() {
      return [] //this.$store.state.client.topCategoryLabel;
    },
    subCategoryLabel() {
      return [] //this.$store.state.client.subCategoryLabel;
    },
    dropzoneOptions() {
      return dropzoneOptions
    }
  },

  validations: {
    matric: { required }, //matric: { required, minLength: minLength(10), maxLength: maxLength(11) },
    category: { required },
    message: { required, minLength: minLength(10) }
  },

  components: {
    VueEditor,
    BackIcon,
    FaqModal,
    vueDropzone: vue2Dropzone
  }
}
</script>
